export default "__VITE_ASSET__w_F7qjYf__"